import React, { useState, useEffect } from 'react';
import { app } from '../firebase';
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import Loader from '../components/Loader';
import PrimaryButton from '../components/buttons/PrimaryButton';
import { useUser } from '../contexts/UserContext';

const db = getFirestore(app);

const Notes = () => {
  const [notes, setNotes] = useState('');
  const [initialNotes, setInitialNotes] = useState('');
  const [loader, setLoader] = useState(true);
  const [saving, setSaving] = useState(false);

  // contexte de l'utilisateur connecté
  const user = useUser();

  // Récupération des notes existantes
  useEffect(() => {
    const fetchNotes = async () => {
      try {
        if (
          !user ||
          !user.user ||
          !user.user.userData ||
          !user.user.userData.lastCoownershipLoaded ||
          !user.user.user
        ) {
          setLoader(false);
          return;
        }

        const path =
          user.user.userData.lastCoownershipLoaded.path +
          '/usersProvider/' +
          user.user.user.uid;

        const docRef = doc(db, path);
        const snap = await getDoc(docRef);

        if (snap.exists()) {
          const data = snap.data();
          const existingNotes = data.notes || '';
          setNotes(existingNotes);
          setInitialNotes(existingNotes);
        } else {
          setNotes('');
          setInitialNotes('');
        }
      } catch (error) {
        console.error('Erreur lors du chargement des notes :', error);
      } finally {
        setLoader(false);
      }
    };

    fetchNotes();
  }, [user]);

  const hasChanges = notes !== initialNotes;

  const handleSave = async () => {
    if (!hasChanges || saving) return;

    try {
      setSaving(true);

      const path =
        user.user.userData.lastCoownershipLoaded.path +
        '/usersProvider/' +
        user.user.user.uid;

      const docRef = doc(db, path);

      // On fusionne pour ne pas écraser les autres champs du document
      await setDoc(docRef, { notes }, { merge: true });

      setInitialNotes(notes);
    } catch (error) {
      console.error('Erreur lors de la sauvegarde des notes :', error);
    } finally {
      setSaving(false);
    }
  };

  if (loader) {
    return <Loader />;
  }

  return (
    <div className="w-full h-full flex flex-col">
      <h2 className="text-xl font-semibold mb-4 text-gray-800">Notes sur la copropriété</h2>

      <textarea
        className="flex-1 w-full border border-gray-300 rounded-md p-3 resize-none focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
        placeholder="Rédigez ici vos notes…"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
      />

      <div className="mt-4 flex justify-end">
        <PrimaryButton
          type="button"
          value={saving ? 'Sauvegarde…' : 'Sauvegarder'}
          loading={saving}
          bgColor={hasChanges ? 'bg-primary' : 'bg-gray-300'}
          onClick={handleSave}
          disabled={!hasChanges || saving}
        />
      </div>
    </div>
  );
};

export default Notes;
